export default "__VITE_ASSET__mlqOetQa__"